module.exports = __webpack_public_path__ + "img/guide6.81f92405.png";